export default function(data) {
var __t, __p = '';
__p += '<div class="no-results">\n  <h2>We\'re sorry, we couldn\'t find any coupons that match your search</h2>\n  <div class="no-results-message">Check back frequently, or check out some of our most popular coupons below!</div>\n</div>\n<div class="coupons-feed coupon-layout" id="coupons-feed"></div>\n';
return __p
}